module.exports = __webpack_public_path__ + "d524a136b5351f9eeef8df537ac5f6a0.svg";